import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useAppSelector } from "../../redux/store";
import { Spacing } from "../../theme/Spacing";
import { BaseTask } from "../../model/task/Task";
import { AtiraTabs } from "../AtiraTabs";
import { ActivityTab } from "../activity-timeline/ActivityTab";
import { taskSliceSelectors } from "../../redux/task/task.selector";
import { TaskInfoTab } from "./components/TaskInfoTab";

const StyledTabs = styled(AtiraTabs)`
  padding-inline: 0;
  padding-top: ${Spacing.s};
  height: 100%;

  .ant-tabs-content,
  .ant-tabs-tabpane-active {
    height: 100%;
  }

  .ant-tabs-nav::before {
    display: none;
  }

  .ant-tabs-nav-list {
    width: 100% !important;
    justify-content: space-between !important;
  }

  .ant-tabs-tab {
    flex-grow: 1;
    justify-content: center;
  }
`;

interface TaskDetailsProps {
  hideActions?: boolean;
  task?: BaseTask;
}

export const TaskDetails: React.FC<TaskDetailsProps> = ({
  task: _task,
  hideActions,
}) => {
  const { t } = useTranslation();

  const task =
    useAppSelector((s) =>
      taskSliceSelectors.selectTaskById(s, _task?._id || ""),
    ) || _task;

  if (!task) {
    return null;
  }

  return (
    <StyledTabs
      items={[
        {
          key: "info",
          label: t("common.info"),
          children: <TaskInfoTab task={task} hideActions={hideActions} />,
        },
        {
          key: "activity",
          label: t("common.activity"),
          children: <ActivityTab entity={task} />,
        },
      ]}
    />
  );
};
